// Bumped by hand on every deploy: ДД.ММ.NN — day, month, sub-version counter for that day
// (resets to 01 on a new day). Shown in Settings so it's obvious whether a deploy landed.
export const APP_VERSION = '10.09.02';
